import { render } from "./SuggestionModal.vue?vue&type=template&id=46dc93e7&scoped=true"
import script from "./SuggestionModal.vue?vue&type=script&lang=js"
export * from "./SuggestionModal.vue?vue&type=script&lang=js"

import "./SuggestionModal.vue?vue&type=style&index=0&id=46dc93e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dc93e7"]])

export default __exports__